export { default } from './QuillAlternate'
